import React, { useContext, useEffect, useState } from 'react';
import { globalStateContext, globalDispatchContext } from 'store';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';

interface AuthGuardProps {
  children: React.ReactChild;
  path: string;
}
export default function AuthGuard({
  children,
  path,
}: AuthGuardProps): JSX.Element {
  const { auth, ...other } = useContext(globalStateContext);
  const { dispatch } = useContext(globalDispatchContext);
  const session = sessionStorage.getItem('digiV-session');

  return (
    <>
      {session && auth && session === auth.hash ? (
        <Route path={path} exact>
          {children}
        </Route>
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: path },
          }}
        />
      )}
    </>
  );
}
